import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  // 容器样式 - 最外层边框
  container: css`
    position: relative;
    padding: 0 15px 10px;
    overflow: visible;
    border: 2px solid transparent;
    transition: all 0.3s ease;

    &.drag-over {
      border: 2px dashed #000;
      background: rgba(0, 0, 0, 0.02);
    }
  `,

  // 主内容区域
  mainArea: css`
    border-radius: 20px;
    overflow: visible;
    background: #fff;
  `,

  // 发送区域
  senderWrap: css`
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: var(--yb-input-bg-color);
    border: 0.5px solid var(--widget-line, rgba(0, 0, 0, 0.08));
    border-radius: 20px;
    box-sizing: border-box;
    caret-color: var(--yb-input-caret-color);
    flex: auto;
    font-size: 14px;
    line-height: 22px;
    padding: 10px 12px 8px;
    position: relative;
    z-index: 1;
    transition-duration: 0.2s;
    transition-property:
      color, background-color, border-color, text-decoration-color, fill,
      stroke, box-shadow;
    transition-timing-function: linear;
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.08);
  `,

  contextBar: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  `,

  contextHeader: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex: 0 0 auto;
    min-width: 0;
  `,

  contextFiles: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1 1 auto;
    min-width: 0;
  `,

  // 输入框和按钮容器
  inputAndButtons: css`
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
  `,

  // 文本输入框容器
  textAreaWrapper: css`
    flex: 1;
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 4px;
    min-height: 44px;

    /* 移除所有蓝色效果 */
    &:focus-within {
      border-color: #d9d9d9;
      box-shadow: none;
    }

    .ant-input:disabled {
      background: transparent !important;
    }

    &::placeholder {
      color: #bfbfbf;
    }
  `,

  // 文本输入框
  textArea: css`
    flex: 1;
    border: none;
    background: transparent;
    font-size: 14px;
    line-height: 1.5;
    padding: 12px 0;
    outline: none;
    color: #262626;
  `,

  inlineInputWrapper: css`
    position: relative;
    flex: 1;
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 0 4px;
    background: #fff;
  `,

  inlineInput: css`
    width: 100%;
    min-height: 24px;
    max-height: 112px;
    overflow-y: auto;
    outline: none;
    border: none;
    color: #262626;
    font-size: 14px;
    line-height: 24px;
    white-space: pre-wrap;
    word-break: break-word;
  `,

  inlinePlaceholder: css`
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    color: #bfbfbf;
    font-size: 14px;
    line-height: 24px;
    pointer-events: none;
    user-select: none;
  `,

  inlineTag: css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 180px;
    height: 22px;
    padding: 0 7px;
    margin: 0 3px;
    vertical-align: baseline;
    border-radius: 6px;
    border: 1px solid #d6e4ff;
    background: #f0f7ff;
    color: #0958d9;
    font-size: 12px;
    line-height: 20px;
    user-select: none;

    .xadk-inline-tag-label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .xadk-inline-tag-close {
      cursor: pointer;
      color: #597ef7;
      font-size: 12px;
      line-height: 1;
    }

    &[data-xadk-inline-mention-type="knowledge"],
    &[data-xadk-inline-mention-type="knowledge_directory"],
    &[data-xadk-inline-mention-type="knowledge_file"],
    &[data-xadk-inline-mention-type="kb"] {
      border-color: #f1f1f1;
      background: #f1f1f1;
      color: #1a1a1a;

      .xadk-inline-tag-close {
        color: #8c8c8c;
      }
    }
  `,

  // 按钮组
  buttonGroup: css`
    display: flex;
    gap: 8px;
    align-items: center;
    height: 36px;
  `,

  // 按钮统一样式
  iconButton: css`
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  `,

  // 清空按钮
  clearButton: css`
    border: 1px solid #f0f0f0;
    background: #fff;
    color: #8c8c8c;

    &:hover {
      border-color: #d9d9d9;
      color: #262626;
      background: #fafafa;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,

  // 上传按钮
  uploadButton: css`
    border: 1px solid #f0f0f0;
    background: #fff;

    &:hover {
      //
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      border-color: #f0f0f0;
      background: #fafafa;
    }
  `,

  // 发送按钮
  sendButton: css`
    background: #000;
    border: none;
    color: #fff;

    &:hover:not(:disabled) {
      background: #333; /* 悬停状态 */
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: #cccccc;
      color: #fff;
    }

    &.stop {
      //

      &:hover:not(:disabled) {
        //
      }

      &:disabled {
        background: #cccccc; /* 禁用状态也保持淡灰色 */
      }
    }
  `,

  // 底部提示
  tip: css`
    margin: 12px 0;
    text-align: center;
    font-size: 12px;
    color: #8c8c8c;
  `,

  actionBar: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 36px;
  `,

  actionBarLeft: css`
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  `,

  actionBarRight: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
  `,

  // 快捷键弹出列表外层容器
  quickListWrapper: css`
    position: absolute;
    left: 0;
    bottom: 100%;
    margin-bottom: 4px;
    z-index: 100;
  `,

  // 快捷键弹出列表
  quickList: css`
    max-height: 320px;
    width: 280px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.12);
  `,

  quickListHeader: css`
    padding: 12px 16px 0;
    font-size: 13px;
    font-weight: 500;
    color: #8c8c8c;
  `,

  quickListBody: css`
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
  `,

  quickListEmpty: css`
    padding: 24px 16px;
    text-align: center;
    color: #8c8c8c;
    font-size: 13px;
  `,

  quickListGroup: css`
    padding: 8px 16px 4px;
    font-size: 11px;
    font-weight: 500;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  `,

  quickListItem: css`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: #f5f5f5;
    }

    &.active {
      background: #f0f7ff;
    }

    .quick-list-item-icon {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      background: #f5f5f5;
      flex-shrink: 0;
    }

    .quick-list-item-content {
      flex: 1;
      min-width: 0;
    }

    .quick-list-item-label {
      font-size: 13px;
      font-weight: 500;
      color: #262626;
      line-height: 1.4;
    }

    .quick-list-item-desc {
      font-size: 12px;
      color: #8c8c8c;
      line-height: 1.4;
    }
  `,

  // 输入框内标签
  inputTags: css`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0 8px;
  `,

  inputTag: css`
    margin: 0;
    font-size: 12px;
    border-radius: 6px;
  `,
}));
